<template>
    <div class="modal fade" id="perfilChangeLinkedin" role="dialog">
      <div class="modal-dialog modal-dialog-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h2 class="certa first-title">{{$t("LinkedIn")}}</h2>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group input-blue">
                <input v-model="linkedin" type="tel" class="form-control" name="linkedin" placeholder="Linkedin" required>
                <span v-if="error" class="error-msg-modal">{{error}}</span>
              </div>
            </form>
          </div>

          <div class="modal-footer offset-top-20">
            <button v-on:click="sendChangeLinkedin()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="nunito btn-yellow-save">
              <span v-if="!loadingChange">Salvar</span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <button v-on:click="closeModal()" class="nunito close-btn">{{$t("Fechar")}}</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { ATT_USER } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";
  import { required, minLength } from 'vuelidate/lib/validators'
  import modalAlert from "./modalAlert";
  import swal from "sweetalert";

  export default {
    name: "perfil-change-linkedin",
    components: {
      modalAlert
    },
    props:['userObj'],
    data() {
      return {
        alertMsg: {},
        emitValue: {
          value: '',
          random: ''
        },
        linkedin: '',
        error: '',
        loadingChange: false
      }
    },
    watch: {
      emitValue : function(val){
        this.$emit('update:actionLinkedin', val)
      }
    },
    methods: {
      closeModal() {
        $('#perfilChangeLinkedin').modal('toggle');
      },
      sendChangeLinkedin() {
        if (!this.$v.linkedin.$invalid) {
          var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
          var regex = new RegExp(expression);

          if(this.linkedin.match(regex)) {
            this.userObj.linkedInUrl = this.linkedin;
            UTIL_SERVICE.console("DATA SEND:", this.userObj);
            REQUEST_SERVICE.put(ATT_USER, this.userObj).then((response) => {
              UTIL_SERVICE.console("RESULT ATT_USER:", response);

              $('#perfilChangeLinkedin').modal('toggle');
              this.emitValue = {value: this.linkedin, random: Math.floor(Math.random() * 500)};

              swal(this.$t("Aviso"), this.$t("Dados atualizado com sucesso."), "success");
            }).catch((reason) => {
              $('#perfilChangeLinkedin').modal('toggle');

              reason.response.data.erros.map((value, index) => {
                swal(this.$t("Aviso"), value.value, "error");
              });
            });
          } else {
            swal(this.$t("Aviso"), this.$t("Por favor, informe um perfil válido. Caso não saiba como, acesse o linkedin, clique em visualizar perfil e copie a url do navegador."), "error");
          }
        } else {
          this.error = "Campo obrigatório.";
        }
      }
    },
    validations: {
      linkedin: {
        required,
        minLength: minLength(3)
      }
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/perfilChangeLinkedin.vue